import Restful from "lib/restful";

/** 결과값은 "EmailNotFound" 혹은 "cognito". */
const toUrlSafeBase64 = value => {
  const utf8Bytes = new TextEncoder().encode(value);
  let binary = "";

  utf8Bytes.forEach(byte => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
};

const checkEmailExist = async email => {
  const emailBase64 = toUrlSafeBase64(email);
  const { res } = await Restful.getWhetherEmailExistAPI(emailBase64);
  const { emailExist, isGoogleAuthUser, isEmailAuthUser } = res;
  return { emailExist, isGoogleAuthUser, isEmailAuthUser };
};

const checkUsernameExist = async username => {
  const { code, errInfo } = await Restful.getWhetherUsernameExistAPI(username);
  switch (code) {
    case "ok":
      return { message: "UsernameNotFound" };
    case "AlreadyExist":
      return { message: "AlreadyExist" };
    case "ReservedWord":
      return { message: "ReservedWord" };
    case "error":
    default:
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
  }
};

const deleteUnlinkedCognitoUser = async email => {
  const emailBase64 = toUrlSafeBase64(email);

  const { code, errInfo } = await Restful.deleteUnlinkedCognitoUserAPI({
    emailBase64
  });
  switch (code) {
    case "ok":
      return { message: "AvailableEmail" };
    case "AlreadyExist":
      return { message: "AlreadyExist" };
    case "error":
    default:
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
  }
};

export { checkEmailExist, checkUsernameExist, deleteUnlinkedCognitoUser };
